// extracted by mini-css-extract-plugin
export default {"card":"style_card__QUz3w","title":"style_title__cv07p","card__footer":"style_card__footer__K2gUD","pub_date":"style_pub_date__FPDvZ"};